import { C, FONTS } from '../../tokens/design';

export default function Card({ children, style = {}, ...props }) {
  return (
    <div style={{
      background: `linear-gradient(180deg, ${C.s1}, ${C.s1})`,
      border: `1px solid ${C.b1}`,
      borderRadius: 8,
      boxShadow: '0 16px 40px rgba(0,0,0,0.16), inset 0 1px 0 rgba(255,255,255,0.03)',
      overflow: 'hidden',
      ...style,
    }} {...props}>{children}</div>
  );
}

export function CardHeader({ title, sub, action }) {
  return (
    <div style={{
      padding: '13px 16px',
      borderBottom: `1px solid ${C.b1}`,
      background: `linear-gradient(180deg, ${C.s2}80, transparent)`,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
    }}>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 750, color: C.t1, fontFamily: FONTS.heading, lineHeight: 1.25 }}>
          {title}
        </div>
        {sub && <div style={{ fontSize: 10, color: C.t3, marginTop: 3, lineHeight: 1.4 }}>{sub}</div>}
      </div>
      {action && <div style={{ flexShrink: 0 }}>{action}</div>}
    </div>
  );
}
